
import { Component } from '@theme/component';

class RevealList extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.button = this.querySelector('[data-more-button]');
    if (!this.button) return;

    this.step = Number(this.dataset.step) || 2;
    this.perRow = Number(this.dataset.perRow) || 1;
    this.button.addEventListener('click', () => this.reveal());
  }

  reveal() {
    const hidden = this.querySelectorAll('[data-reveal-item][hidden]:not([data-out])');
    const scoperti = Array.from(hidden).slice(0, this.step * this.perRow);
    scoperti.forEach((item) => {
      item.hidden = false;
    });

    const span = this.querySelector('[data-row-span]');
    if (span) {
      const righe = this.querySelectorAll('[data-reveal-item]:not([hidden])').length / this.perRow;
      span.style.setProperty('--r-end', righe + 2);
    }

    if (!this.querySelector('[data-reveal-item][hidden]:not([data-out])')) {
      const more = this.querySelector('[data-more]');
      const perdeIlFuoco = more?.contains(document.activeElement);
      more.hidden = true;
      if (perdeIlFuoco) {
        const primo = scoperti[0];
        const bersaglio = primo?.matches('a, button') ? primo : primo?.querySelector('a, button');
        (bersaglio ?? primo)?.focus({ preventScroll: true });
      }
    }
  }
}

if (!customElements.get('reveal-list-component')) customElements.define('reveal-list-component', RevealList);
